/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../services/common.service';

export class ActionAlertModalComponentContext{
 configObj: any;
}

@Component({
  templateUrl: './action-alert-modal.component.html',
  styleUrls: ['./action-alert-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ActionAlertModalComponent {
  @Input() context!: ActionAlertModalComponentContext;
  @Output() onClose = new EventEmitter<string>();
  public isFromEligibilityReset: boolean = false;
  public configObj: any = {};

  constructor(public bsModalRef: BsModalRef,private commonService: CommonService) {}

  ngOnInit() {
    if (this.context) {
      this.configObj = this.context.configObj;
    }
  }

  getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public closeModalWindow(event: any) {
    event.stopPropagation();
    this.onClose.emit('closed');
    this.bsModalRef.hide();
  }

  public confirmAction(event: any) {
    event.stopPropagation();
    this.onClose.emit('confirmed');
    this.bsModalRef.hide();
  }

}